/*
 * Contextul de autentificare, separat de componenta care il furnizeaza.
 *
 * Fisier propriu ca sa fie un modul care exporta numai valori, nu si
 * componente: cu `verbatimModuleSyntax` si cu reincarcarea la cald a Vite,
 * un modul care exporta si o componenta si un context isi pierde starea la
 * fiecare salvare, si depanarea arata ca un bug de sesiune.
 */

import { createContext, use } from 'react';
import type { ShopUser } from '../api/types';

/**
 * `booting` acopera si verificarea sesiunii restaurate, si schimbul biletului
 * de SSO. Cat tine, nu se deseneaza nici aplicatia, nici loginul: altfel omul
 * vede o clipa ecranul de login desi era autentificat, sau invers.
 */
export type AuthPhase = 'booting' | 'ready';

export interface AuthValue {
  phase: AuthPhase;
  authenticated: boolean;
  user: ShopUser | null;
  /* `can` nu mai e aici: singurul ecran care se desena dupa el era cel de
     aprobari, iar aprobarea s-a mutat pe tichet. Contextul poarta doar ce
     citeste cineva. */
  /** Eroarea intoarsa de intoarcerea din SSO, aratata pe ecranul de login. */
  ssoError: { message: string; code: string } | null;
  signIn: (username: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
  dismissSsoError: () => void;
}

export const AuthContext = createContext<AuthValue | null>(null);

export function useAuth(): AuthValue {
  const value = use(AuthContext);
  if (!value) throw new Error('useAuth used outside AuthProvider');
  return value;
}
